var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPay = function SvgPay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 15.4062C6.48007 15.4062 6.58278 15.4374 6.67015 15.4958C6.75751 15.5542 6.8256 15.6371 6.86581 15.7342C6.90602 15.8313 6.91654 15.9381 6.89604 16.0411C6.87554 16.1442 6.82495 16.2389 6.75065 16.3132C6.67635 16.3874 6.58169 16.438 6.47864 16.4585C6.37559 16.479 6.26877 16.4685 6.1717 16.4283C6.07463 16.3881 5.99166 16.32 5.93328 16.2326C5.87491 16.1453 5.84375 16.0426 5.84375 15.9375C5.84375 15.7966 5.89972 15.6615 5.99935 15.5618C6.09898 15.4622 6.2341 15.4062 6.375 15.4062Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.625 26.0312C27.7301 26.0312 27.8328 26.0624 27.9201 26.1208C28.0075 26.1792 28.0756 26.2621 28.1158 26.3592C28.156 26.4563 28.1665 26.5631 28.146 26.6661C28.1255 26.7692 28.0749 26.8639 28.0007 26.9382C27.9264 27.0124 27.8317 27.063 27.7286 27.0835C27.6256 27.104 27.5188 27.0935 27.4217 27.0533C27.3246 27.0131 27.2417 26.945 27.1833 26.8576C27.1249 26.7703 27.0938 26.6676 27.0938 26.5625C27.0938 26.4216 27.1497 26.2865 27.2493 26.1868C27.349 26.0872 27.4841 26.0312 27.625 26.0312Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8125 10.625H3.1875C2.01389 10.625 1.0625 11.5764 1.0625 12.75V29.75C1.0625 30.9236 2.01389 31.875 3.1875 31.875H30.8125C31.9861 31.875 32.9375 30.9236 32.9375 29.75V12.75C32.9375 11.5764 31.9861 10.625 30.8125 10.625Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 25.5C19.3472 25.5 21.25 23.5972 21.25 21.25C21.25 18.9028 19.3472 17 17 17C14.6528 17 12.75 18.9028 12.75 21.25C12.75 23.5972 14.6528 25.5 17 25.5Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1875 6.375H30.8125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 2.125H26.5625",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pay.c4489d6c.svg";
export { ForwardRef as ReactComponent };